import styled, { css } from 'styled-components'
import { background } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { BORDER_RADIUS } from 'Constants/Landing'

export type ContainerBgProps = {
  bg?: 'primary' | 'secondary' | 'light' | 'almond' | 'tertiary'
}

export type ContentProps = {
  almond?: boolean
  background?: string
  bottomLeft?: boolean
  bottomRight?: boolean
  light?: boolean
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  topLeft?: boolean
  topRight?: boolean
}

const primaryCss = ({ primary }: ContentProps) =>
  primary &&
  css`
    background-color: ${themeGet('colors.bg.primary')};
  `

const secondaryCss = ({ secondary }: ContentProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.bg.secondary')};
  `

const tertiaryCss = ({ tertiary }: ContentProps) =>
  tertiary &&
  css`
    background-color: ${themeGet('colors.bg.tertiary')};
  `

const lightCss = ({ light }: ContentProps) =>
  light &&
  css`
    background-color: ${themeGet('colors.bg.light')};
  `

const bottomLeftCss = ({ bottomLeft }: ContentProps) =>
  bottomLeft &&
  css`
    border-bottom-left-radius: ${BORDER_RADIUS}px;
  `

const bottomRightCss = ({ bottomRight }: ContentProps) =>
  bottomRight &&
  css`
    border-bottom-right-radius: ${BORDER_RADIUS}px;
  `

const topLeftCss = ({ topLeft }: ContentProps) =>
  topLeft &&
  css`
    border-top-left-radius: ${BORDER_RADIUS}px;
  `

const topRightCss = ({ topRight }: ContentProps) =>
  topRight &&
  css`
    border-top-right-radius: ${BORDER_RADIUS}px;
  `

const almondCss = ({ almond }: ContentProps) =>
  almond &&
  css`
    background-color: ${themeGet('colors.bg.almond')};
  `

const bgCss = ({ bg }: ContainerBgProps) =>
  bg === 'primary' ||
  bg === 'secondary' ||
  bg === 'light' ||
  bg === 'almond' ||
  bg === 'tertiary'
    ? css`
        background-color: ${themeGet(`colors.bg.${bg}`)};
      `
    : css`
        background-color: ${bg};
      `

const shouldForwardProp = (prop: string | number) => {
  return ![
    'bg',
    'almond',
    'background',
    'bottomLeft',
    'bottomRight',
    'light',
    'primary',
    'secondary',
    'tertiary',
    'topLeft',
    'topRight',
  ].includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerBgProps>`
  width: 100%;
  background-color: ${themeGet('colors.white')};

  ${bgCss};
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<ContentProps>`
  width: 100%;
  height: 64px;
  background-color: ${themeGet('colors.white')};

  ${almondCss}
  ${primaryCss};
  ${secondaryCss};
  ${tertiaryCss}
  ${lightCss};

  ${bottomLeftCss};
  ${bottomRightCss};
  ${topLeftCss};
  ${topRightCss};

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    border-radius: 0;
    height: 32px;
  }

  ${background};
`
